// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/extract-text-webpack-plugin/loader.js?{"remove":true}!./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/UiSwitch.vue
 ** module id = 173
 ** module chunks = 0
 **/